import { useDispatch } from "react-redux";
import { useState } from "react";

import { getFormDetailsById } from "../../../actionCreator/webToLeadActionCreater";

export const useFormDetails = () => {
  const dispatch = useDispatch();
  const [formDetails, setFormDetails] = useState();

  const getDetailsById = async (id) => {
    const res = await dispatch(getFormDetailsById(id));
    if (res?.id) {
      setFormDetails(res);
    }
  };

  return {
    getDetailsById,
    formDetails,
  };
};
